import Service from "core/decorators/Service";
import IResolverService from "core/service/resolver/IResolverService";
import ConfigUtil from "core/util/config/ConfigUtil";
import ServiceRegistry from "core/util/ServiceRegistry";
import { IUploadError, IUploadOptions, IUploadResponse, IUploadService } from "../IUploadService";

interface IUploadMicroserviceResponse {
	success: boolean;
	message?: string;
	fileName?: string;
	s3Url?: string;
	cdnUrl?: string;
}

@Service()
export default class DefaultUploadService extends IUploadService {

	public static EXTERNAL_MESSAGE_MUTATION = 'mutation { message: externalMessage_one_create { id callbackUrl } }';

	public getServiceId() { return IUploadService.DEFAULT_ID; }

	protected handleUpload(
		file: File,
		options: IUploadOptions,
		resolve: (res: IUploadResponse) => void,
		reject: (reason: IUploadError[]) => void
	): void {

		// 1 - get callback details
		ServiceRegistry
			.get(IResolverService)
			.execute(DefaultUploadService.EXTERNAL_MESSAGE_MUTATION)
			.then((res) => {

				/**
				 * callback url is an API that the heavy-load-services project
				 * can call to retrieve upload information (s3 target url, etc).
				 * this must be provided for the upload to work.
				 */
				const { callbackUrl } = res.data.message;

				const formData = new FormData();

				formData.append("apiCallbackUrl", callbackUrl);
				formData.append("file", file, file.name);

				const xhr = new XMLHttpRequest();

				if (typeof options.onProgress === 'function') {
					xhr.upload.onprogress = options.onProgress;
				}

				xhr.onreadystatechange = () => {
					if (xhr.readyState === 4) {
						if (xhr.status === 200) {
							try {
								const o: IUploadMicroserviceResponse = JSON.parse(xhr.responseText);
								if (o.success) {
									resolve({
										url: o.cdnUrl,
										name: o.fileName,
										type: file.type
									});
								} else {
									reject([this.getError('UPLOAD')]);
								}
							} catch(e) {
								reject([this.getError('UPLOAD')]);
							}
						}
					}
				};

				xhr.open('POST', ConfigUtil.getEnvConfig().uploadUri, true);

				xhr.send(formData);

			})
			.catch(() => {
				reject([this.getError('AUTHORIZE')]);
			});
	}
}



// WEBPACK FOOTER //
// ./src/core/service/upload/impl/DefaultUpload.service.ts